export default __webpack_public_path__ + "static/media/icons8-laptop-settings.a02398c5.svg";